// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeSearch_home-search__4Vy0Z {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.HomeSearch_home-search__4Vy0Z p {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 30px !important;
}
.HomeSearch_home-search__4Vy0Z .HomeSearch_search__Rb2Bo {
  display: flex;
  align-items: center;
  width: 700px;
  height: 40px;
  border-radius: 40px;
  border: 1px solid var(--light-grey);
  padding: 3px;
}
.HomeSearch_home-search__4Vy0Z .HomeSearch_search__Rb2Bo .HomeSearch_search-bar__sqIhe {
  border-right: 1px solid var(--light-grey);
  width: 90%;
}
.HomeSearch_home-search__4Vy0Z .HomeSearch_search__Rb2Bo .HomeSearch_search-bar__sqIhe .HomeSearch_ant-select__CIyzm {
  width: 100%;
}
.HomeSearch_home-search__4Vy0Z .HomeSearch_search__Rb2Bo .HomeSearch_search-bar__sqIhe .HomeSearch_input-search__fvhvf {
  width: 100%;
  font-size: 14px;
  height: 100%;
  padding: 5px;
  border: none;
  border-radius: 10px;
  outline: none;
}
.HomeSearch_home-search__4Vy0Z .HomeSearch_search__Rb2Bo .HomeSearch_input-search__fvhvf:hover {
  background: var(--background-nav-hover);
}
.HomeSearch_home-search__4Vy0Z .HomeSearch_search__Rb2Bo .HomeSearch_input-search__fvhvf:focus {
  background: white;
}
.HomeSearch_home-search__4Vy0Z .HomeSearch_search-mobile__L42yG {
  display: none;
}
@media only screen and (max-width: 480px) {
  .HomeSearch_home-search__4Vy0Z .HomeSearch_search__Rb2Bo {
    display: none;
  }
  .HomeSearch_home-search__4Vy0Z .HomeSearch_search-mobile__L42yG {
    width: 100%;
    display: flex;
    height: 40px;
    border-radius: 40px;
    border: 1px solid var(--light-grey);
    align-items: center;
  }
  .HomeSearch_home-search__4Vy0Z .HomeSearch_search-mobile__L42yG .HomeSearch_search-bar__sqIhe {
    border-right: 1px solid var(--light-grey);
    width: 90%;
  }
  .HomeSearch_home-search__4Vy0Z .HomeSearch_search-mobile__L42yG .HomeSearch_search-bar__sqIhe .HomeSearch_ant-select__CIyzm {
    width: 100%;
  }
  .HomeSearch_home-search__4Vy0Z .HomeSearch_search-mobile__L42yG .HomeSearch_search-bar__sqIhe .HomeSearch_input-search__fvhvf {
    width: 100%;
    font-size: 14px;
    height: 100%;
    padding: 5px;
    border: none;
    border-radius: 10px;
    outline: none;
  }
  .HomeSearch_home-search__4Vy0Z .HomeSearch_search-mobile__L42yG .HomeSearch_input-search__fvhvf:hover {
    background: var(--background-nav-hover);
  }
  .HomeSearch_home-search__4Vy0Z .HomeSearch_search-mobile__L42yG .HomeSearch_input-search__fvhvf:focus {
    background: white;
  }
  .HomeSearch_home-search__4Vy0Z p {
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 20px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Home/Components/HomeSearch/HomeSearch.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AACF;AAAE;EACE,eAAA;EACA,iBAAA;EACA,8BAAA;AAEJ;AAAE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,mCAAA;EACA,YAAA;AAEJ;AADI;EACE,yCAAA;EACA,UAAA;AAGN;AAFM;EACE,WAAA;AAIR;AAFM;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;AAIR;AADI;EACE,uCAAA;AAGN;AADI;EACE,iBAAA;AAGN;AAAE;EACE,aAAA;AAEJ;AAAE;EACE;IACE,aAAA;EAEJ;EAAE;IACE,WAAA;IACA,aAAA;IACA,YAAA;IACA,mBAAA;IACA,mCAAA;IACA,mBAAA;EAEJ;EAAI;IACE,yCAAA;IACA,UAAA;EAEN;EADM;IACE,WAAA;EAGR;EADM;IACE,WAAA;IACA,eAAA;IACA,YAAA;IACA,YAAA;IACA,YAAA;IACA,mBAAA;IACA,aAAA;EAGR;EAAI;IACE,uCAAA;EAEN;EAAI;IACE,iBAAA;EAEN;EACE;IACE,eAAA;IACA,iBAAA;IACA,8BAAA;EACJ;AACF","sourcesContent":[".home-search {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  p {\n    font-size: 40px;\n    font-weight: bold;\n    margin-bottom: 30px !important;\n  }\n  .search {\n    display: flex;\n    align-items: center;\n    width: 700px;\n    height: 40px;\n    border-radius: 40px;\n    border: 1px solid var(--light-grey);\n    padding: 3px;\n    .search-bar {\n      border-right: 1px solid var(--light-grey);\n      width: 90%;\n      .ant-select {\n        width: 100%;\n      }\n      .input-search {\n        width: 100%;\n        font-size: 14px;\n        height: 100%;\n        padding: 5px;\n        border: none;\n        border-radius: 10px;\n        outline: none;\n      }\n    }\n    .input-search:hover {\n      background: var(--background-nav-hover);\n    }\n    .input-search:focus {\n      background: white;\n    }\n  }\n  .search-mobile {\n    display: none;\n  }\n  @media only screen and (max-width: 480px) {\n    .search {\n      display: none;\n    }\n    .search-mobile {\n      width: 100%;\n      display: flex;\n      height: 40px;\n      border-radius: 40px;\n      border: 1px solid var(--light-grey);\n      align-items: center;\n\n      .search-bar {\n        border-right: 1px solid var(--light-grey);\n        width: 90%;\n        .ant-select {\n          width: 100%;\n        }\n        .input-search {\n          width: 100%;\n          font-size: 14px;\n          height: 100%;\n          padding: 5px;\n          border: none;\n          border-radius: 10px;\n          outline: none;\n        }\n      }\n      .input-search:hover {\n        background: var(--background-nav-hover);\n      }\n      .input-search:focus {\n        background: white;\n      }\n    }\n    p {\n      font-size: 30px;\n      font-weight: bold;\n      margin-bottom: 20px !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home-search": `HomeSearch_home-search__4Vy0Z`,
	"search": `HomeSearch_search__Rb2Bo`,
	"search-bar": `HomeSearch_search-bar__sqIhe`,
	"ant-select": `HomeSearch_ant-select__CIyzm`,
	"input-search": `HomeSearch_input-search__fvhvf`,
	"search-mobile": `HomeSearch_search-mobile__L42yG`
};
export default ___CSS_LOADER_EXPORT___;
